export default __webpack_public_path__ + "static/media/tabSubscriptionsIcon.9dd6b702.svg";